import CalendarSettings from "./CalendarSettings";

export default CalendarSettings;